<template>
  <div class="my-qr-card" :class="{publish: publish}">
    <TitleBar :text="$t('MyQrCard.topic')" :showIconButton="false" @clickCloseButton="clickCloseButton" v-if="!publish" />
    <div class="back-space">
      <div class="qr-card-image-container" v-if="util.getUserAgentMeta() === 'iOS browser'">
        <img ref="qrCardImage" src="" v-show="isGeneratedImage">
      </div>
      <div id="qr-card" class="body" ref="qrCard">
        <div class="frame">
          <button class="download-button" @click="download" v-if="!hideDownloadBtn && !publish && !isInLineBrowser">
            <img :src="util.getImagePath('download_blue@2x.png')" :srcset="util.getImageSet('download_blue')">
          </button>
          <div class="note">
            {{ $t('MyQrCard.note') }}
          </div>
          <div class="qr-group">
            <div class="loading-animation primary" v-show="!isGeneratedQr"></div>
            <vue-qr :text="userUrl" :size="2100" :margin="16" :callback="callbackGenerateQr" v-show="false"></vue-qr>
            <img class="qr" :src="generatedQrSrc" v-show="isGeneratedQr">
            <img class="logo" :src="util.getImagePath('user_blue@2x.png')" :srcset="util.getImageSet('user_blue')" v-show="isGeneratedQr">
          </div>
          <div class="detail">
            <div class="display-name">
              {{ userProfile.display_name }}
            </div>
            <div class="fullname" v-if="false">
              {{ `${userProfile.profile_firstname || ''} ${userProfile.profile_lastname || ''}` }}
            </div>
          </div>
          <div class="banner">
            <img class="logo" :src="util.getImagePath(`promptpai_logo_${$i18n.locale}@original.png`)">
          </div>
        </div>
      </div>
      <transition name="fade">
        <div class="finish-download-message" v-if="isShowFinishDownloadMessage">{{ finishDownloadMessage }}</div>
      </transition>
    </div>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar.vue'
import VueQr from 'vue-qr'
import { setTimeout } from 'timers'

var html2Canvas = require('html2canvas')

export default {
  name: 'MyQrCard',
  components: {
    TitleBar,
    VueQr
  },
  props: {
    userInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    publish: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      userProfile: {}, // this.publish ? this.userInfo : JSON.parse(this.getPromptPaiCookies('UserProfile')),
      isGeneratedQr: false,
      generatedQrSrc: '',
      hideDownloadBtn: true,
      isGeneratedImage: false,
      finishDownloadMessage: '',
      isShowFinishDownloadMessage: false
    }
  },
  computed: {
    userUrl () {
      var self = this
      return `${window.location.origin}/sendto/${self.userProfile.uid}`
    },
    isInLineBrowser () {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      if (window.liff) {
        if (userAgent !== 'Android application' && userAgent !== 'iOS application' && process.env.NODE_ENV !== 'development') {
          return window.liff.isInClient()
        }
      }
      return false
    }
  },
  mounted () {
    var self = this
    window.gtag('event', 'view_item', {'event_label': 'view_my_qr_card'})
    self.userProfile = self.publish ? self.userInfo : JSON.parse(self.getPromptPaiCookies('UserProfile'))
    self.userProfile.profile_firstname = self.userProfile.profile_firstname !== null ? self.userProfile.profile_firstname : ''
    self.userProfile.profile_lastname = self.userProfile.profile_lastname !== null ? self.userProfile.profile_lastname : ''
  },
  methods: {
    clickCloseButton () {
      var self = this
      self.$router.back()
    },
    callbackGenerateQr (data) {
      var self = this
      self.generatedQrSrc = data
      self.isGeneratedQr = true
      // setTimeout(() => {
      //   console.log('SUCCESS') // for capture with phantom
      // }, 1000)
      if (self.util.getUserAgentMeta() !== 'iOS browser') {
        self.hideDownloadBtn = false
      } else {
        self.hideDownloadBtn = true
        setTimeout(() => {
          html2Canvas(self.$refs['qrCard'], {
            scale: 5
          }).then(canvas => {
            var img = self.$refs['qrCardImage']
            img.src = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
            self.hideDownloadBtn = false
            self.isGeneratedImage = true
          })
        }, 30)
      }
    },
    download () {
      var self = this
      self.hideDownloadBtn = true
      setTimeout(() => {
        html2Canvas(self.$refs['qrCard'], {
          scale: 2
        }).then(canvas => {
          var url = `${window.location.origin}/ws/qr/u/${self.userProfile.uid}?lang=${self.$i18n.locale}`
          var imageUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
          var base64 = imageUrl.split(',')[1]
          var userAgent = self.util.getUserAgentMeta()
          if (userAgent === 'iOS application') {
            window.saveImageFinished = (error) => {
              if (error !== '' && error !== null && error !== undefined) {
                self.finishDownloadMessage = self.$t('MyQrCard.errorSave')
              } else {
                self.finishDownloadMessage = self.$t('MyQrCard.successSave')
              }
              self.isShowFinishDownloadMessage = true
              setTimeout(() => {
                self.isShowFinishDownloadMessage = false
              }, 2000)
            }
            // window.location.href = `https://native.saveimage?image=${base64}`
            window.location.href = `https://native.saveimage?url=${encodeURIComponent(url)}`
            // native.capture
          } else if (userAgent === 'Android application') {
            window.blockWriteFile = () => {
              self.finishDownloadMessage = self.$t('MyQrCard.blockWrite')
              self.isShowFinishDownloadMessage = true
              setTimeout(() => {
                self.isShowFinishDownloadMessage = false
              }, 2000)
            }
            window.saveImageFinished = (error) => {
              if (error !== '' && error !== null && error !== undefined) {
                self.finishDownloadMessage = self.$t('MyQrCard.errorSave')
              } else {
                self.finishDownloadMessage = self.$t('MyQrCard.successSave')
              }
              self.isShowFinishDownloadMessage = true
              setTimeout(() => {
                self.isShowFinishDownloadMessage = false
              }, 2000)
            }
            Android.save(base64, `promptpai_user_${self.userProfile.uid}`)
          } else {
            var link = document.createElement('a')
            link.href = imageUrl
            link.download = `promptpai_user_${self.userProfile.uid}.png`
            link.click()
          }
          self.hideDownloadBtn = false
        })
      }, 30)
    }
  }
}
</script>

<style scoped>
  .my-qr-card {
    width: 320px;
    height: 480px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    margin-top: auto;
    margin-bottom: auto;
  }

  .qr-card-image-container {
    display: none;
  }

  .body {
    height: 430px;
    padding: 8px;
    box-sizing: border-box;
    background: rgb(255, 255, 255);
  }

  .frame {
    border: 4px solid rgb(34, 84, 156);
    border-radius: 4px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: relative;
  }

  button.download-button {
    padding: 0px;
    border: none;
    background-color: transparent;
    width: 24px;
    height: 24px;
    cursor: pointer;
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  button.download-button > img {
    width: 24px;
    height: 24px;
  }

  .note {
    text-align: center;
    margin-top: 16px;
    padding: 8px 8px 0px 8px;
    line-height: 1.75;
  }

  .qr-group {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 212px;
    padding: 0px 8px;
  }

  .qr-group > .qr {
    width: 180px;
    height: 180px;
    margin: 16px;
  }

  .qr-group > .logo {
    position: absolute;
    width: 28px;
    height: 28px;
    background-color: rgb(255, 255, 255);
    border-radius: 16px;
    padding: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
    -webkit-appearance: none;
  }

  .detail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0px 8px;
  }

  .detail > div {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    width: 100%;
    text-align: center;
  }

  .detail > div.display-name {
    font-size: 22px;
    font-weight: bold;
    line-height: 1.75;
  }

  .detail > div.fullname {
    line-height: 1.75;
  }

  .banner {
    background-color: rgb(34, 84, 156);
    width: 100%;
    padding: 10px 0px 8px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 23px;
    position: absolute;
    bottom: 0px;
    left: 0px;
  }

  .banner > img {
    height: 32px;
    max-width: 100%;
  }

  .finish-download-message {
    position: absolute;
    color: rgb(255, 255, 255);
    background-color: rgb(255, 255, 255, 0.1);
    width: fit-content;
    border-radius: 16px;
    padding: 0px 16px;
    width: max-content;
    height: 32px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 32px;
    left: auto;
    right: auto;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 2s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  @media only screen and (max-width: 768px) {
    .my-qr-card {
      width: 100%;
      min-width: 320px;
      height: 100%;
      border-radius: 0px;
    }

    .back-space {
      width: 100%;
      height: calc(100% - 50px);
      background-color: rgb(0, 0, 0);
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
    }

    .qr-card-image-container {
      display: block;
      height: 430px;
      width: 320px;
      position: absolute;
      z-index: 1;
      top: calc((100% - 430px) / 2);
      left: calc((100% - 320px) / 2);
      background-color: rgb(0, 0, 0);
    }

    .qr-card-image-container > img {
      height: 430px;
      width: 320px;
    }

    .frame {
      height: calc(430px - 8px - 8px);
      width: calc(320px - 8px - 8px);
    }
  }

  .my-qr-card.publish {
    width: 100%;
    min-width: 320px;
    height: 100%;
    border-radius: 0px;
  }

  .publish .back-space {
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .publish .frame {
    height: calc(430px - 8px - 8px);
    width: calc(320px - 8px - 8px);
  }
</style>



// WEBPACK FOOTER //
// src/components/MyQrCard.vue